import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

/* eslint-disable @typescript-eslint/explicit-function-return-type */
import round from "lodash/round";
import { DataErrorCheckoutTypes } from "../api/Checkout/types";
import { NamedObservable } from "../helpers";
import { LocalStorageItems } from "../repository";
import { StateItems } from "./types";
export var SaleorState =
/*#__PURE__*/
function (_NamedObservable) {
  _inherits(SaleorState, _NamedObservable);

  // Should be changed it in future to shop object containing payment gateways besides all the shop data
  function SaleorState(repository, networkManager) {
    var _this;

    _classCallCheck(this, SaleorState);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SaleorState).call(this));

    _this.provideCheckout =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(onError, forceReload) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.isCheckoutCreatedOnline() && !forceReload)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!navigator.onLine) {
                  _context.next = 7;
                  break;
                }

                _context.next = 5;
                return _this.provideCheckoutOnline(onError);

              case 5:
                _context.next = 8;
                break;

              case 7:
                _this.provideCheckoutOffline(forceReload);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.providePayment =
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(forceReload) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.providePaymentOffline(forceReload);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.providePaymentGateways =
    /*#__PURE__*/
    function () {
      var _ref3 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(onError) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.providePaymentGatewaysOnline(onError);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.onCheckoutUpdate = function (checkout) {
      _this.checkout = checkout;
      _this.summaryPrices = _this.calculateSummaryPrices(checkout);

      _this.notifyChange(StateItems.CHECKOUT, _this.checkout);

      _this.notifyChange(StateItems.SUMMARY_PRICES, _this.summaryPrices);
    };

    _this.onPaymentUpdate = function (payment) {
      _this.payment = payment;

      _this.notifyChange(StateItems.PAYMENT, _this.payment);
    };

    _this.onPaymentGatewaysUpdate = function (paymentGateways) {
      _this.availablePaymentGateways = paymentGateways;

      _this.notifyChange(StateItems.PAYMENT_GATEWAYS, _this.availablePaymentGateways);
    };

    _this.isCheckoutCreatedOnline = function () {
      var _this$checkout;

      return (_this$checkout = _this.checkout) === null || _this$checkout === void 0 ? void 0 : _this$checkout.id;
    };

    _this.provideCheckoutOnline =
    /*#__PURE__*/
    function () {
      var _ref4 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(onError) {
        var checkout, _ref5, data, _error, checkoutModel;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // 1. Try to take checkout from backend database
                checkout = _this.repository.getCheckout();

                if (!(checkout === null || checkout === void 0 ? void 0 : checkout.token)) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 4;
                return _this.networkManager.getCheckout(checkout === null || checkout === void 0 ? void 0 : checkout.token);

              case 4:
                _ref5 = _context4.sent;
                data = _ref5.data;
                _error = _ref5.error;

                if (!_error) {
                  _context4.next = 11;
                  break;
                }

                onError(_error, DataErrorCheckoutTypes.GET_CHECKOUT);
                _context4.next = 14;
                break;

              case 11:
                if (!data) {
                  _context4.next = 14;
                  break;
                }

                _this.repository.setCheckout(_objectSpread({}, data, {
                  cartPromoCode: checkout.cartPromoCode
                })); // this.updateCheckout(data);


                return _context4.abrupt("return");

              case 14:
                // 2. Try to take checkout from local storage
                checkoutModel = _this.repository.getCheckout();

                if (checkoutModel) {
                  _this.onCheckoutUpdate(checkoutModel);
                }

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.provideCheckoutOffline = function (forceReload) {
      // 1. Try to take checkout from runtime memory (if exist in memory - has any checkout data)
      if (_this.checkout && !forceReload) {
        return;
      } // 2. Try to take checkout from local storage


      var checkoutModel = _this.repository.getCheckout();

      if (checkoutModel) {
        _this.onCheckoutUpdate(checkoutModel);
      } else {
        _this.repository.setCheckout({});
      }
    };

    _this.providePaymentOffline = function (forceReload) {
      // 1. Try to take checkout from runtime memory (if exist in memory - has any checkout data)
      if (_this.payment && !forceReload) {
        return;
      } // 2. Try to take checkout from local storage


      var paymentModel = _this.repository.getPayment();

      if (paymentModel) {
        _this.onPaymentUpdate(paymentModel);
      } else {
        _this.repository.setPayment({});
      }
    };

    _this.providePaymentGatewaysOnline =
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(onError) {
        var _ref7, data, error;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.networkManager.getPaymentGateways();

              case 2:
                _ref7 = _context5.sent;
                data = _ref7.data;
                error = _ref7.error;

                if (error) {
                  onError(error, DataErrorCheckoutTypes.GET_PAYMENT_GATEWAYS);
                }

                _this.onPaymentGatewaysUpdate(data);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x6) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.calculateSummaryPrices = function (checkout) {
      var _checkout$promoCodeDi, _checkout$cartPromoCo;

      var items = checkout === null || checkout === void 0 ? void 0 : checkout.lines;
      var shippingMethod = checkout === null || checkout === void 0 ? void 0 : checkout.shippingMethod;
      var promoCodeDiscount = checkout === null || checkout === void 0 ? void 0 : (_checkout$promoCodeDi = checkout.promoCodeDiscount) === null || _checkout$promoCodeDi === void 0 ? void 0 : _checkout$promoCodeDi.discount;
      var cartPromoCodeDiscount = checkout === null || checkout === void 0 ? void 0 : (_checkout$cartPromoCo = checkout.cartPromoCode) === null || _checkout$cartPromoCo === void 0 ? void 0 : _checkout$cartPromoCo.discount;
      var checkoutCreated = checkout === null || checkout === void 0 ? void 0 : checkout.id;

      if (items && items.length) {
        var firstItemTotalPrice = items[0].totalPrice;

        if (firstItemTotalPrice) {
          var _shippingMethod$price, _shippingMethod$price2;

          var shippingPrice = _objectSpread({}, shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.price, {
            amount: (shippingMethod === null || shippingMethod === void 0 ? void 0 : (_shippingMethod$price = shippingMethod.price) === null || _shippingMethod$price === void 0 ? void 0 : _shippingMethod$price.amount) || 0,
            currency: (shippingMethod === null || shippingMethod === void 0 ? void 0 : (_shippingMethod$price2 = shippingMethod.price) === null || _shippingMethod$price2 === void 0 ? void 0 : _shippingMethod$price2.currency) || firstItemTotalPrice.gross.currency
          });

          var _items$reduce = items.reduce(function (prevVals, item) {
            var _item$totalPrice, _item$totalPrice2;

            prevVals.itemsNetPrice += ((_item$totalPrice = item.totalPrice) === null || _item$totalPrice === void 0 ? void 0 : _item$totalPrice.net.amount) || 0;
            prevVals.itmesGrossPrice += ((_item$totalPrice2 = item.totalPrice) === null || _item$totalPrice2 === void 0 ? void 0 : _item$totalPrice2.gross.amount) || 0;
            return prevVals;
          }, {
            itemsNetPrice: 0,
            itmesGrossPrice: 0
          }),
              itemsNetPrice = _items$reduce.itemsNetPrice,
              itmesGrossPrice = _items$reduce.itmesGrossPrice;

          var subtotalPrice = _objectSpread({}, firstItemTotalPrice, {
            gross: _objectSpread({}, firstItemTotalPrice.gross, {
              amount: round(itmesGrossPrice, 2)
            }),
            net: _objectSpread({}, firstItemTotalPrice.net, {
              amount: round(itemsNetPrice, 2)
            })
          });

          var discount = _objectSpread({}, promoCodeDiscount, {
            amount: (checkoutCreated ? promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.amount : cartPromoCodeDiscount === null || cartPromoCodeDiscount === void 0 ? void 0 : cartPromoCodeDiscount.amount) || 0,
            currency: (checkoutCreated ? promoCodeDiscount === null || promoCodeDiscount === void 0 ? void 0 : promoCodeDiscount.currency : cartPromoCodeDiscount === null || cartPromoCodeDiscount === void 0 ? void 0 : cartPromoCodeDiscount.currency) || firstItemTotalPrice.gross.currency
          });

          var totalPrice = _objectSpread({}, subtotalPrice, {
            gross: _objectSpread({}, subtotalPrice.gross, {
              amount: round(itmesGrossPrice + shippingPrice.amount - discount.amount, 2)
            }),
            net: _objectSpread({}, subtotalPrice.net, {
              amount: round(itemsNetPrice + shippingPrice.amount - discount.amount, 2)
            })
          });

          return {
            discount: discount,
            shippingPrice: shippingPrice,
            subtotalPrice: subtotalPrice,
            totalPrice: totalPrice
          };
        }
      }

      return {};
    };

    _this.repository = repository;
    _this.networkManager = networkManager;
    repository.subscribeToChange(LocalStorageItems.CHECKOUT, _this.onCheckoutUpdate);
    repository.subscribeToChange(LocalStorageItems.PAYMENT, _this.onPaymentUpdate);
    return _this;
  }

  return SaleorState;
}(NamedObservable);